import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { SortOption } from 'entities/kyrgyzstan/model'
import { sortOptions } from 'entities/kyrgyzstan/model'

import { CheckBoxSimple } from 'shared/ui/check-box-simple'
import { FilterSection } from 'shared/ui/filter-section'
import { BaseOption, OptionsList } from 'shared/ui/options-list'

import s from './styles.module.scss'

interface KyrgyzstanSortWidgetProps {
  className?: string
  selectedId: string
  onChange: (sort: SortOption) => void
}

interface KyrgyzstanSortOption extends SortOption, BaseOption {}

export const KyrgyzstanSortWidget = ({
  className,
  selectedId,
  onChange,
}: KyrgyzstanSortWidgetProps) => {
  const { t } = useTranslation()

  const options: KyrgyzstanSortOption[] = sortOptions.map((option) => ({
    id: option.value,
    ...option,
  }))

  return (
    <div className={clsx(s.container, className)}>
      <FilterSection title={t('kyrgyzstan_block.sort.section_title')}>
        <OptionsList<KyrgyzstanSortOption>
          options={options}
          onOptionClick={onChange}
          renderContent={(option) => (
            <span className="medium-16">{t(option.label)}</span>
          )}
          renderControl={(option) => (
            <CheckBoxSimple
              isChecked={option.value === selectedId}
              isBigSize
            />
          )}
        />
      </FilterSection>
    </div>
  )
}
